import React from 'react';
import PropTypes from 'prop-types';

import { MAX_TOTAL_SCORE } from '../../constants/common';

import style from './GameOverBlock.module.scss';

const GameOverBlock = ({ score, restartGame }) => {
  const isPerfectResult = score === MAX_TOTAL_SCORE;
  const perfectText = `Вы набрали максимальное количество очков: ${MAX_TOTAL_SCORE}.`;
  const failText = `Ваш результат: ${score} / ${MAX_TOTAL_SCORE}. Попробуем еще раз?`;
  const gameoverText = isPerfectResult ? perfectText : failText;

  const handlerRestartGameClick = () => {
    restartGame();
  };

  return (
    <div className={style.GameOverBlock}>
      <p className={style.GameOverBlock__header}>Поздравляем!</p>
      <p className={style.GameOverBlock__text}>{gameoverText}</p>

      {!isPerfectResult && (
        <button
          className={style.GameOverBlock__button}
          type="button"
          onClick={handlerRestartGameClick}
        >
          Попробовать еще раз
        </button>
      )}
    </div>
  );
};

GameOverBlock.propTypes = {
  score: PropTypes.number.isRequired,
  restartGame: PropTypes.func.isRequired,
};

export default GameOverBlock;
